@switch (processNotification().process.status) {
@case(PROCESS_STATUS.waitingInQueue){
<app-notification [isReadable]="false" [isDeletable]="true" (deleteClicked)="toggleDeleteConfirmation()">

	<app-notification-header>
		<ng-container [ngTemplateOutlet]="spinner" />
		<span class="mat-body-small">
			{{"In Warteschlange" | translate : "label-in-queue"}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
	</app-notification-content>

	<app-notification-footer>
		<button mat-stroked-button class="process-notification__action" appInlineConfirmationTrigger
			#trigger="appInlineConfirmationTrigger">
			<ogs-m3-icon matButtonIcon icon="pause" />
			{{"Anhalten" | translate : "action-pause"}}
		</button>
		<app-inline-confirmation [trigger]="trigger" (confirm)="pauseProcess()">
			<app-inline-confirmation-message>
				{{"Wirklich anhalten?" | translate : "confirmation-paragraph-pause"}}
			</app-inline-confirmation-message>
			<app-inline-confirmation-operators>
				<button mat-button appInlineConfirmationConfirm class="confirmation-action--error">
					{{"Anhalten" | translate : "confirmation-confirm-pause-action"}}
				</button>
				<button mat-button appInlineConfirmationCancel>
					{{"Nein" | translate : "confirmation-cancel-pause-action"}}
				</button>
			</app-inline-confirmation-operators>
		</app-inline-confirmation>
		<ng-container [ngTemplateOutlet]="deleteConfirmation" />
	</app-notification-footer>
</app-notification>
}

@case(PROCESS_STATUS.paused){
<app-notification [isReadable]="false" [isDeletable]="true" (deleteClicked)="toggleDeleteConfirmation()">

	<app-notification-header>
		<span class="mat-body-small">
			{{"Angehalten in Warteschlange" | translate : "label-stopped-in-queue"}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
	</app-notification-content>

	<app-notification-footer>
		<button mat-stroked-button class="process-notification__action" (click)="restartProcess()">
			<ogs-m3-icon matButtonIcon icon="refresh" />
			{{"Fortsetzen" | translate : "action-restart"}}
		</button>
		<ng-container [ngTemplateOutlet]="deleteConfirmation" />
	</app-notification-footer>
</app-notification>
}

@case(PROCESS_STATUS.running){
<app-notification [isReadable]="false" [isDeletable]="false">

	<app-notification-header>
		<ng-container [ngTemplateOutlet]="spinner" />
		<span class="mat-body-small">
			{{"Auswertung läuft" | translate : "label-evaluation-running"}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
	</app-notification-content>

	<app-notification-footer>
		<p class="mat-body-small">
			{{"Ihre Anfrage wird bearbeitet ..." | translate : "label-request-is-being-processed"}}
		</p>
	</app-notification-footer>
</app-notification>
}

@case(PROCESS_STATUS.failed){
<app-notification [isReadable]="false" [isDeletable]="true" (deleteClicked)="toggleDeleteConfirmation()">

	<app-notification-header>
		<span class="mat-body-small process-notification__heading--failed">
			{{"Vorgang fehlgeschlagen" | translate : "label-process-failed"}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
	</app-notification-content>

	<app-notification-footer>
		<p class="mat-body-small">
			{{"Fehler während Auswertung. Sie müssen den Vorgang neu anstoßen." | translate :
			"paragraph-process-failed"}}
		</p>
		<ng-container [ngTemplateOutlet]="deleteConfirmation" />
	</app-notification-footer>
</app-notification>
}

@case(PROCESS_STATUS.evaluationComplete){
<app-notification [isReadable]="false" [isDeletable]="false">

	<app-notification-header>
		<ng-container [ngTemplateOutlet]="spinner" />
		<span class="mat-body-small">
			{{"Download wird vorbereitet" | translate : "label-preparing-download"}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
	</app-notification-content>

	<app-notification-footer>
		<p class="mat-body-small">
			{{"Ihr Download wird bereitgestellt ..." | translate : "paragraph-preparing-download"}}
		</p>
	</app-notification-footer>
</app-notification>
}

@case(PROCESS_STATUS.readyToDownload){
<app-notification [isReadable]="isNotificationReadable()" [isDeletable]="true" [(isSeen)]="_isSeen"
	(isSeenChange)="_changeIsSeen($event)" (deleteClicked)="toggleDeleteConfirmation()">

	<app-notification-header>
		<span class="mat-body-small">
			{{"Bereit zum Download" | translate : 'label-ready-to-download'}}
		</span>
	</app-notification-header>

	<app-notification-content>
		<section class="process-notification__details">
			<ng-container [ngTemplateOutlet]="processName" />
			<ng-container [ngTemplateOutlet]="date" />
		</section>
		<button mat-stroked-button class="process-notification__action" (click)="downloadProcess()">
			<ogs-m3-icon matButtonIcon icon="download" />
			{{"Download" | translate : 'action-download'}}
		</button>
	</app-notification-content>

	<app-notification-footer>
		<p class="mat-body-small">
			{{"Noch {0} Tage gültig" | translate : "label-days-available" | template :
			remainingDaysForDownloadParams()}}
		</p>
		<ng-container [ngTemplateOutlet]="deleteConfirmation" />
	</app-notification-footer>
</app-notification>
}
}

<ng-template #spinner>
	<mat-spinner [diameter]="15" />
</ng-template>

<ng-template #processName>
	<strong class="mat-label-large">
		{{processNotification().process.type}} · {{processNotification().process.name}} ·
		{{processNotification().process.contextName}}
	</strong>
</ng-template>

<ng-template #date>
	@let createdAt = processNotification().process.createdAt;
	@if (createdAt) {
	<app-date-time [date]="createdAt" />
	}
</ng-template>

<ng-template #deleteConfirmation>
	<app-inline-confirmation [(isOpen)]="isDeleteConfirmationOpen">
		<app-inline-confirmation-message>
			{{"Wirklich Löschen?" | translate : "label-delete-confirmation"}}
		</app-inline-confirmation-message>
		<app-inline-confirmation-operators>
			<button mat-button appInlineConfirmationConfirm class="confirmation-action confirmation-action--error"
				(click)="deleteProcess()">
				<ogs-m3-icon matButtonIcon icon="trash-can" />
				{{"Löschen" | translate : 'action-aboard-deletion'}}
			</button>
			<button mat-button appInlineConfirmationCancel>
				{{"Abbrechen" | translate : 'action-aboard-deletion'}}
			</button>
		</app-inline-confirmation-operators>
	</app-inline-confirmation>
</ng-template>